import {
  ITaskTemplate,
  ITimelineItem
} from '@dadohr/shared/domainTypes/experience';
import { ONE_DAY } from '@dadohr/shared/domainTypes/time';
import { Typography } from '@material-ui/core';
import { compact } from 'lodash';
import { useMemo } from 'react';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import { joinWithCommaAndAnd } from '../../../../../../services/enumerate';
import { LightMdToJsx } from '../../../../../../services/formatter';
import { TriggeredItemsList } from '../../../TriggeredItemsList';
import { TaskBuilderContext } from '../types';

export const CauseItemDeletionConfirmationBody = ({
  value,
  onDelete,
  triggeredItems,
  tplContext
}: {
  value: ITaskTemplate;
  onDelete: () => Promise<any>;
  triggeredItems: ITimelineItem[];
  tplContext: TaskBuilderContext;
}) => {
  const { t } = useUnsafeTranslation();
  const causeItems = useMemo(() => {
    return compact(
      (value.timing.type === 'triggered' ? value.timing.dependentOn : []).map(
        (x) => {
          return x.itemType === 'TASK'
            ? tplContext.tasks.find((tsk) => tsk.id === x.itemId)
            : null;
        }
      )
    );
  }, [value, tplContext]);
  return (
    <FlexContainerVertical spacing={2}>
      <Typography variant="body1">
        {t(
          triggeredItems.length === 1
            ? 'Deleting this task will also affect the following triggered timeline item'
            : 'Deleting this task will also affect the following triggered timeline items'
        )}
        :
      </Typography>
      <TriggeredItemsList
        triggeredItems={triggeredItems}
        tplContext={tplContext}
      />

      {value.timing.type === 'fixed' ? (
        <LightMdToJsx>
          {t(
            triggeredItems.length === 1
              ? 'It will be converted to "Fixed Date" scheduling with a start on **day {{ start }}**.'
              : 'They will be converted to "Fixed Date" scheduling with a start on **day {{ start }}**.',
            {
              start: Math.floor(value.timing.end / ONE_DAY) + 1
            }
          )}
        </LightMdToJsx>
      ) : (
        <>
          <LightMdToJsx>
            {t('They will be now triggered by **{{ items }}**.', {
              items: joinWithCommaAndAnd(
                causeItems.map((x) => x.title),
                t
              )
            })}
          </LightMdToJsx>
          <LightMdToJsx>
            {t('To change this, edit the settings for each item.')}
          </LightMdToJsx>
        </>
      )}
    </FlexContainerVertical>
  );
};
